import React, { Component } from 'react';
import './Fields.css'
import { Link } from 'react-router-dom';
import eye from '../static/vectors/eye.svg';
import eyeSlash from '../static/vectors/eye-slash.svg';
import AuthService from '../services/auth';
import Api from '../services/api';
import Modal from 'react-modal';
import checkCircle from '../static/vectors/check-circle.svg';

class SettingsEmail extends Component {

  constructor(props) {
    super(props);

    this.state = {
      fields: {
        email: '',
        email2: '',
        password: '',
      },
      passwordVisible: false,
      isModalOpen: false,
      modalMessage: '',
      canSubmit: false,
    };
  }

  componentDidMount() {
    (new Api()).get('/users/current',{}, AuthService.getAuthCookie())
      .then(response => {
        this.setState({
          user: response.user,
        });
      });
  }

  handleSubmit(e) {
    e.preventDefault();
    const { fields, user } = this.state;
    (new Api()).post(`/users/${user.id}/update-email`,fields, AuthService.getAuthCookie())
      .then(response => {
        this.setState({
          isModalOpen: true,
          modalMessage: response.message,
          canSubmit: false,
        });
      });
  }

  handleFieldChange(e, name) {
    let fields = this.state.fields;

    fields[name] = e.target.value;

    this.setState({ fields,
    canSubmit: true, });
  }

  togglePasswordField(field) {
    let newState = this.state;
    newState[`${field}Visible`] = !this.state[`${field}Visible`];
    this.setState(newState);
  }

  closeModal() {
    this.setState({
      isModalOpen: false,
    });
  }

  render() {
    const { title } = this.props;
    const { passwordVisible , fields, isModalOpen, modalMessage, canSubmit } = this.state;
    return (
      <div className="col col-12 col-md-8">
        <div className="title">
          {title}
        </div>
        <form>
          <div className="field-container text">
            <div className="field-title">New email address</div>
            <div className="row">
              <div className="col">
                <input
                  type="text"
                  id="email"
                  name="email"
                  placeholder="New email address"
                  value={fields.email}
                  onChange={e => {this.handleFieldChange(e, e.target.name)}}
                />
              </div>
            </div>
          </div>
          <div className="field-container text">
            <div className="field-title">Confirm New email address</div>
            <div className="row">
              <div className="col">
                <input
                  type="text"
                  id="email2"
                  name="email2"
                  placeholder="Confirm new email address"
                  value={fields.email2}
                  onChange={e => {this.handleFieldChange(e, e.target.name)}}
                />
              </div>
            </div>
          </div>
          <div className="field-container text">
            <div className="field-title">Your password</div>
            <div className="row">
              <div className="col">
                <input
                  type={(passwordVisible)?'text':'password'}
                  id="password"
                  name="password"
                  placeholder="Your password"
                  value={fields.password}
                  onChange={e => {this.handleFieldChange(e, e.target.name)}}
                />
                <div className="icon">
                  <img
                    src={(passwordVisible?eye:eyeSlash)}
                    onClick={() => {this.togglePasswordField('password')}}
                    alt="Visibility"
                  />
                </div>
              </div>
            </div>
          </div>
          <Link
            to="/settings"
            className="cancel"
          >
            cancel
          </Link>
          <button
            className="btn submit"
            disabled={!canSubmit}
            onClick={(e) => {this.handleSubmit(e);}}
          >
            Save profile
          </button>
          <Modal
            isOpen={isModalOpen}
            onRequestClose={() => {this.closeModal()}}
            contentLabel="Example Modal"
            style={{
              content: {
                top: '50%',
                bottom: 'auto',
                left: '50%',
                right: 'auto',
                transform: 'translate(-50%, -50%)',
              }
            }}
          >
            <div className="content text-center">
              <img src={checkCircle} alt="check" />
              <div className="message">{modalMessage}</div>
              <button onClick={() => {this.closeModal()}}> Close X</button>
            </div>
          </Modal>
        </form>
      </div>
    )
  }
}

export default SettingsEmail;


// WEBPACK FOOTER //
// ./src/components/SettingsEmail.js